import {
  DownloadOutlined,
  FacebookFilled,
  LinkedinFilled,
  TwitterOutlined,
  MailFilled,
} from "@ant-design/icons";
import "./presentation.css";
import pen from "../../../assets/coding.jpg";
import { onButtonClick } from "../../presentation";
import { Button } from "antd";

export const PresentationMobile = () => {
  return (
    <div className="m-presentation">
      <div className="s1">
        <h3>SALUT, JE SUIS</h3>
        <h1>Halimatou Diallo</h1>
        <p>UX / UI DESIGN, DEVELOPPEUSE FRONT END</p>
      </div>
      <div className="s2">
        <div className="deco0"></div>
        {/* <div className="deco1"></div> */}
        <img src={pen} alt="imageProfil" />
        <h1>Halimatou Diallo</h1>

        <div className="job">
          <p className="p1">Développeuse Front End</p>
          <p>UX / UI Design</p>
        </div>

        <div
          className="contact"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <span>
            dialllohali2017@gmail.com
            <br />
          </span>
          <span>+221 78 139 22 17</span>
        </div>

        <div className="list-icons">
          <LinkedinFilled /> <FacebookFilled /> <MailFilled />{" "}
          <TwitterOutlined />
        </div>
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          size="large"
          onClick={onButtonClick}
        >
          Download CV
        </Button>
      </div>
    </div>
  );
};
